const values = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: '创新理念',
    desc: '性巴克始终坚持前瞻性思维，不断突破传统边界，以创新驱动品牌发展，引领行业潮流。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '用心品质',
    desc: '从选材到工艺，性巴克对每一个细节都精益求精，确保交付给用户的每一件产品都经得起时间考验。',
  },
  {
    icon: 'ri-user-star-line',
    title: '用户至上',
    desc: '性巴克将用户体验放在首位，倾听每一位用户的声音，持续优化产品与服务，创造真正有价值的产品。',
  },
  {
    icon: 'ri-earth-line',
    title: '可持续发展',
    desc: '性巴克关注人与自然的和谐共生，在品牌运营中践行环保理念，为更美好的未来贡献力量。',
  },
];

export default function ValueSection() {
  return (
    <section className="relative py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label tracking-[0.15em] text-primary-500 uppercase mb-3">
            品牌理念
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            性巴克的
            <span className="text-primary-500">核心价值</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            根植于对美好生活的向往，性巴克以四大核心价值为基石，持续创造独特的品牌体验。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {values.map((v, i) => (
            <div
              key={v.title}
              className="group bg-background-100 rounded-2xl p-6 md:p-7 hover:bg-background-50 transition-all duration-300 border border-transparent hover:border-background-200/70"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${v.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-3">
                {v.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {v.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}